const BASE_PRIME = 'https://lp.maisretorno.com/retorno-prime';
const BASE_PRO = 'https://lp.maisretorno.com/retorno-pro';

export const PRIME_TRACKING_ROUTES = {
  CTAPortfolioShowPL: `${BASE_PRIME}?utm_source=site&utm_medium=portfolio&utm_content=PL`,
  CTAPortfolioBenchmarks: `${BASE_PRIME}?utm_source=site&utm_medium=portfolio&utm_content=benchmarks`,
  CTAPortfolioCorrelation: `${BASE_PRIME}?utm_source=site&utm_medium=portfolio&utm_content=correlation`,
  CTAPortfolioDrawdown: `${BASE_PRIME}?utm_source=site&utm_medium=portfolio&utm_content=drawdown`,
  CTAPortfolioIndicatorType: `${BASE_PRIME}?utm_source=site&utm_medium=portfolio&utm_content=indicator-type`,
  CTAHistoricalProfitability: (medium: string = '') =>
    `${BASE_PRIME}?utm_source=site&utm_medium=${medium}&utm_content=rentabilidade-historica`,
};
